// extracted by mini-css-extract-plugin
export default {"grayBack":"SignUpPopup_grayBack__LDVb4"};